import createBrowserHistory from 'history/createBrowserHistory';
import makeInspectable from 'mobx-devtools-mst';
import {Provider} from 'mobx-react';
import {RouterModel, syncHistoryWithStore} from 'mst-react-router';
import * as React from 'react';
// import teamsModel from '../models/TeamsModel';
import airbnbAuthModel from '../models/airbnbAuthModel';
import airbnbListingDetailModel from '../models/AirbnbListingDetailModel';
import appFeedbackModel from '../models/appFeedbackModel';
import authModel from '../models/authModel';
import botChatModel from '../models/botChatModel';
import chatModel from '../models/chatModel';
import {FetchAirbnbListingsModel} from '../models/IntegrationModel';
import languagesListModel from '../models/LanguagesListModel';
import listingDetailModel from '../models/ListingDetailModel';
import listingsListModel from '../models/ListingsListModel';
import mailingListModel from '../models/MailingListModel';
import otaAccountsListModel from '../models/OtaAccountsListModel';
import promoteListingDetailModel from '../models/PromoteListingDetailModel';
import promoteListingListModel from '../models/PromoteListingListModel';
import reservationsListModel from '../models/ReservationsListModel';
import rolesListModel from '../models/RolesListModel';
import staahListingsDetailModel from '../models/StaahListingDetailModel';
import teamDetailModel from '../models/TeamDetailModel';
import teamSettingDetailModel from '../models/TeamSettingDetailModel';
import teamsListModel from '../models/TeamsListModel';
import userDetailModel from '../models/UserDetailModel';
import usersListModel from '../models/UsersListModel';
import v3ListingListModel from '../models/V3ListingListModel';

const router = RouterModel.create();

const appFeedback = appFeedbackModel.create();
const auth = authModel.create({}, {appFeedback});
// const teams = teamsModel.create({}, {appFeedback, router});
const airbnbAuth = airbnbAuthModel.create({}, {appFeedback, router});
const botChat = botChatModel.create({}, {auth, appFeedback});
const chat = makeInspectable(chatModel.create({}, {auth, appFeedback}));
const reservationsList = makeInspectable(
  reservationsListModel.create({}, {auth, appFeedback})
);
const mailingList = mailingListModel.create({}, {auth, router});
const rolesList = rolesListModel.create({}, {auth, router});
const teamsList = teamsListModel.create({}, {auth, router});
const teamDetail = teamDetailModel.create({}, {auth, router});
const usersList = usersListModel.create({}, {auth, router});
const userDetail = userDetailModel.create({}, {auth, router});
const listingsList = listingsListModel.create({}, {auth, router});
const listingDetail = listingDetailModel.create({}, {auth, router});
const otaAccountsList = otaAccountsListModel.create({}, {auth, router});
const languagesList = languagesListModel.create({}, {auth, router});
const promoteListingList = promoteListingListModel.create({}, {auth, router});
const airbnbListingDetail = airbnbListingDetailModel.create(
  {},
  {auth, router}
);

const promoteListingDetail = promoteListingDetailModel.create(
  {},
  {auth, router}
);

const fetchAirbnbListingsAirbnb = FetchAirbnbListingsModel.create(
  {},
  {auth, router}
);

const teamSettingDetail = teamSettingDetailModel.create({}, {auth, router});
const staahListingsDetail = staahListingsDetailModel.create(
  {},
  {auth, router}
);

const v3ListingList = v3ListingListModel.create({}, {auth, router});

const state = {
  auth,
  // teams,
  airbnbAuth,
  appFeedback,
  chat,
  botChat,
  reservationsList,
  router,
  mailingList,
  teamsList,
  teamDetail,
  rolesList,
  usersList,
  userDetail,
  listingsList,
  listingDetail,
  otaAccountsList,
  languagesList,
  promoteListingList,
  airbnbListingDetail,
  promoteListingDetail,
  fetchAirbnbListingsAirbnb,
  teamSettingDetail,
  staahListingsDetail,
  v3ListingList
};

// Hook up router model to browser history object
export const history = syncHistoryWithStore(createBrowserHistory(), router);

export default class StateProvider extends React.Component<{}, {}> {
  public render() {
    return <Provider {...state} {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/StateProvider/StateProvider.tsx